export enum ChartTypes {
  FUNNEL = "funnel",
  DONUT = "donut",
  BAR = "column",
}
